import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/CloseRounded";
import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import ApiAccount from "../../../core/api/api.account";
import SwalMessage from "../_Components/SwalMessage";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import SplitNumber from "../_Components/SplitNumber";
import { PatternFormat } from "react-number-format";
import moment from "moment-jalaali";
import { UploadFiles } from "../FilesService/UploadFiles";
import { tools } from "../../../core/utils/tools";
import jalaali from "jalaali-js";
import Swal from "sweetalert2";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CardNumberFormat from "../_Components/CardNumberFormat";
import CopyToClipboard from "../_Components/CopyToClipboard";
import { Skeleton } from "@mui/material";
import SelectComponent from "../_Components/ReactSelectComponent";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // استایل پیش‌فرض

moment.locale("fa");
moment.loadPersian();
export const Details = () => {
  let { id } = useParams();
  const [liveData, setLiveData] = useState({ status: 3 });
  const [loadingData, setLoadingData] = useState(true);
  const [formattedCard, setFormattedCard] = useState("");
  const [formattedRialAmount, setFormattedRialAmount] = useState("");
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({ defaultValues: { userWithdrawalId: id } });
  const watchstatus = watch("status", { label: "جدید", value: "جدید" });

  const [enumData, setenumData] = useState([]);
  const [accountSaamaneh, setAccountSaamaneh] = useState([]);
  const [colorFlag, setcolorFlag] = useState(false);
  const getUserWithdrawal = async (ennums) => {
    const response = await ApiUserWithdrawal.getUserWithdrawalById({ id: id });
    if (!_.isEmpty(response) && response.succeeded) {
      setLiveData(response.data);
      setLoadingData(false);

      const formatCard = CardNumberFormat({ number: response.data.destinationAccountCardNumber, onlyNumber: true });
      setFormattedCard(formatCard);

      const formatRialAmount = SplitNumber({ number: response.data.rialAmount });
      setFormattedRialAmount(formatRialAmount);
      setValue("status", ennums?.map(ee => ({ label: ee.title, value: ee.title }))?.find(ee => ee.value == response.data.statusS));
      setValue("statusDesc", response.data.statusDesc);
      if (
        response.data &&
        response.data.rialAmount > response.data.walletUseAvailableAmount &&
        response.data.status != "انجام_شد" &&
        response.data.status != "رد_شده"
      )
        setcolorFlag(true);
      else setcolorFlag(false);
    }
  };
  useEffect(() => {
    (async () => {
      try {
        if (id != undefined) {
          const response2 = await ApiUserWithdrawal.getUserWithdrawalStatus();
          if (!_.isEmpty(response2) && !_.isEmpty(response2.data)) {
            setenumData(response2.data);
          }
          getUserWithdrawal(response2.data);
          setValue("paymentTime", moment().format("HH:mm"));

          const today = new Date();
          const toJalaali = (date) => {
            const jDate = jalaali.toJalaali(date);
            return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
          };
          const formattedToday = toJalaali(today);
          setValue("paymentDateOB", formattedToday);
          const allAccountSaAmaneh = await ApiAccount.getAllAccountSaamaneh({ pageSize: 1, pageNumber: 20 });
          if (!_.isEmpty(allAccountSaAmaneh) && allAccountSaAmaneh.succeeded) {
            setAccountSaamaneh(allAccountSaAmaneh.data);
            setValue("saamanehtype", 0);
          }
        } else {
          setLiveData({});
        }
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (data.status) data.status = data.status.value
    if (data.sourceAccountId) data.sourceAccountId = data.sourceAccountId.value
    try {
      if (data?.paymentDateOB && typeof data.paymentDateOB === "object") {
        data.paymentDate =
          data.paymentDateOB.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
          "/" +
          data.paymentDateOB.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
          "/" +
          data.paymentDateOB.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
      } else {
        data.paymentDate = data.paymentDateOB;
      }
      if (data.paymentDateOB && typeof data.paymentDateOB === "object") {
        data.paymentDate = tools.DateFormat(data.paymentDateOB);
      }

      if (data.status == "جدید") {
        SwalMessage({
          title: "لطفا وضعیت را تغییر دهید",
          iSsuccess: false,
        });
        return;
      } else if (data.status == "انجام_شد" && liveData.isNewDestinationAccount) {
        Swal.fire({
          title: "تایید نهایی درخواست برداشت وجه",
          text: "تاکنون برای این حساب هیچ درخواست برداشت وجهی تایید نشده است، آیا از تایید نهایی درخواست برداشت وجه مطمن هستید؟",
          icon: "question",
          showDenyButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          customClass: {
            actions: "my-actions",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            const resdata = await ApiUserWithdrawal.updateUserWithdrawal(data);
            if (resdata.succeeded) {
              SwalMessage({
                title: "تغییرات این آیتم با موفقیت ثبت شد",
                iSsuccess: true,
              });
              getUserWithdrawal(enumData);
            } else
              SwalMessage({
                title: resdata.message,
                iSsuccess: false,
              });
          }
        });
        return
      }

      const resdata = await ApiUserWithdrawal.updateUserWithdrawal(data);
      if (resdata.succeeded) {
        SwalMessage({
          title: "تغییرات این آیتم با موفقیت ثبت شد",
          iSsuccess: true,
        });
        getUserWithdrawal(enumData);
      } else
        SwalMessage({
          title: resdata.message,
          iSsuccess: false,
        });

    } catch (error) {
    }
  };
  const deleteWithdrawal = async () => {
    Swal.fire({
      title: "حذف فرایند انتخابی",
      text: "درخواست در وضعیت انجام شده هست، آیا قصد حذف عملیات انجام شده را دارید؟",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      cancelButtonText: "انصراف",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        var result = await ApiUserWithdrawal.deleteWithdrawal({ id: id });
        if (result.succeeded)
          SwalMessage({
            title: "با موفقیت انجام شد",
            iSsuccess: true,
          });
        getUserWithdrawal(enumData);
      } else if (result.isDenied) {
      }
    });
  };
  const requiredField = () => {
    if (watchstatus?.value == "انجام شد") return true;
    else return false;
  };

  const clearedata = () => {
    if (getValues("status")?.value != "انجام_شد" && getValues("status")?.value != "" && getValues("status")?.value != "جدید") {
      /* setValue("paymentDate","");
      setValue("paymentTime","");
        setValue("trackingCode","");
        setValue("saamanehtype",""); */
    }
  };
  return (
    <div className={`card card-custom`}>
      <div>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-0 pt-5">
          <div className="card-title align-items-start flex-column">
            <h4 className="card-label font-weight-bolder text-dark">درخواست دریافت وجه</h4>
            <h3 className="text-muted mt-3 font-weight-bold font-size-sm">
              در صورت تایید و یا عدم تایید فرم زیر را تکمیل اطلاعات نمایید
            </h3>
            {/* <br></br> */}
            {/* <span className="text-muted mt-3 font-weight-bold font-size-sm">شماره درخواست : {id}</span> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-0 pb-0">
          <Tippy
            content="مبلغ درخواست داده شده توسط کاربر از موجودی کیف پولش بیشتری است!"
            placement="top"
            hideOnClick={false}
            disabled={liveData.status == 4 || liveData.status == 3 || liveData.walletUseAvailableAmount - liveData.rialAmount >= 0}
          >
            <div className="rounded-2 px-3 py-1 pb-5 mb-8 mt-5" style={{ border: `2px solid ${liveData.status != 4 && liveData.status != 3 && liveData.walletUseAvailableAmount - liveData.rialAmount < 0 ? "rgba(255,0,0,0.5)" : "#585858"}`, backgroundColor: liveData.status != 4 && liveData.status != 3 && liveData.walletUseAvailableAmount - liveData.rialAmount < 0 ? "rgba(255,0,0,0.02)" : "" }}>
              <div
                className="bg-white px-3 position-absolute d-inline-block"
                style={{ marginTop: "-14px", width: "auto" }}
              >
                اطلاعات اصلی
            </div>
              <Row className="mt-4">
                <Row className="p-0 m-0">
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="2"
                    className="mb-4  d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-small opacity-90">نوع درخواست کننده </div>
                    <div className={`fw-500 ${liveData.userType !== "کاربر" && "text-info "}`}>
                      {loadingData && <Skeleton width={50} height={25} />}
                      {!loadingData && (
                        <>
                          {liveData.userType === "تامین کننده" ? (
                            <i className="fa fa-user-tag  text-small mr-1 text-info "></i>
                          ) : liveData.userType === "نماینده" ? (
                            <i className="fa fa-user-alt  text-small mr-1 text-info "></i>
                          ) : (
                            ""
                          )}

                          <span>{liveData.userType}</span>
                        </>
                      )}
                    </div>
                  </Col>
                  {liveData.userType !== "کاربر" && (
                    <Col
                      xs="12"
                      sm="6"
                      md="4"
                      lg="6"
                      xl="2"
                      className="mb-4  d-flex justify-content-between align-items-center d-sm-block"
                    >
                      <div className="mb-sm-1  text-small opacity-90">نام شرکت</div>
                      <div className="fw-500">
                        {loadingData ? <Skeleton width={50} height={25} /> : liveData.companyName}
                      </div>
                    </Col>
                  )}

                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl={liveData.userType !== "کاربر" ? "2" : "3"}
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90">نام تقاضا کننده</div>
                    <div className="fw-500">
                      {loadingData ? <Skeleton width={50} height={25} /> : liveData.userFullName}
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="2"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90">شماره تماس</div>
                    <div className="fw-500">{loadingData ? <Skeleton width={50} height={25} /> : liveData.phoneNumber}</div>
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="2"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90">وضعیت درخواست</div>
                    <div className="fw-500">{loadingData ? <Skeleton width={50} height={25} /> :
                      <span className={`rounded-pill d-inline-block px-4 py-1 text-center ${liveData.status === 4 ? "text-danger bg-light-danger" : liveData.status === 3 ? "text-success bg-light-success" : liveData.status === 1 ? "bg-light-info text-info" : "text-primary bg-light-primary"}`}>
                        {liveData.statusS}
                      </span>
                    }
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="2"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90">موجودی کیف پول</div>
                    <div className="fw-500">
                      {loadingData ? (
                        <Skeleton width={50} height={25} />
                      ) : (
                        <SplitNumber number={liveData.walletAmount}></SplitNumber>
                      )}
                    </div>
                  </Col>
                </Row>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 pr-xl-0 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className={`mb-sm-1  text-small opacity-90 ${colorFlag ? "" : "text-secondary"}`}>
                    موجودی قابل برداشت{" "}
                  </div>
                  <div className={`fw-500 ${colorFlag ? "" : "text-dark"}`}>
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <SplitNumber number={liveData.walletUseAvailableAmount}></SplitNumber>
                    )}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className={`mb-sm-1   text-secondary text-small opacity-90 ${colorFlag ? "" : "text-dark"}`}>
                    رقم درخواستی{" "}
                  </div>
                  <div className={`fw-500 ${liveData.rialAmount > liveData.walletUseAvailableAmount ? "text-danger" : colorFlag ? "" : "text-dark"}`}>
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.rialAmount}
                        htmlText={
                          `<span className="cursor-pointer" data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          formattedRialAmount +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90">تاریخ درخواست</div>
                  <div className="fw-500">
                    {loadingData ? <Skeleton width={50} height={25} /> : liveData.createdPersianTime}
                  </div>
                </Col>
              </Row>
            </div>
          </Tippy>
          <Tippy
            content="برای این حساب هیچ درخواست برداشت وجهی تایید نشده!"
            placement="top"
            hideOnClick={false}
            disabled={!liveData.isNewDestinationAccount}
          >
            <div className="rounded-2 mb-8  px-3 py-1 pb-5" style={{ border: `2px solid ${liveData.isNewDestinationAccount ? "rgb(255,168,0)" : "#585858"}`, backgroundColor: liveData.isNewDestinationAccount ? "rgba(255,168,0,0.05)" : "" }}>
              <div
                className="bg-white px-3 position-absolute d-inline-block"
                style={{ marginTop: "-14px", width: "auto", color: liveData.isNewDestinationAccount ? "rgb(255,168,0)" : "" }}
              >
                اطلاعات حساب{liveData.isNewDestinationAccount && <span style={{ fontSize: 10 }} className="me-1 fw-bold">(جدید)</span>}
              </div>
              <Row className="mt-4 ">
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4  d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90"> شماره درخواست </div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={id}
                        htmlText={
                          `<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          id +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90">نام صاحب حساب</div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.destinationAccountAccountOwnerName}
                        htmlText={
                          `<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          liveData.destinationAccountAccountOwnerName +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90">نام بانک</div>
                  <div className="fw-500">
                    {loadingData ? <Skeleton width={50} height={25} /> : liveData.destinationAccountBank}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="2"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90"> نام صاحب کارت</div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.destinationAccountCardOwnerName}
                        htmlText={
                          `<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          liveData.destinationAccountCardOwnerName +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>

                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="4"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90">شماره حساب</div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.destinationAccountAccountNumber}
                        htmlText={
                          `<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          liveData.destinationAccountAccountNumber +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>
                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="4"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90"> شماره کارت</div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.destinationAccountCardNumber}
                        htmlText={`<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">   
                      ${formattedCard} 
                       </span>    </span>`}
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>

                <Col
                  xs="12"
                  sm="6"
                  md="4"
                  lg="6"
                  xl="4"
                  className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                >
                  <div className="mb-sm-1  text-secondary text-small opacity-90"> شماره شبا</div>
                  <div className="fw-500">
                    {loadingData ? (
                      <Skeleton width={50} height={25} />
                    ) : (
                      <CopyToClipboard
                        showIcon={true}
                        copyDate={liveData.destinationAccountShebaNumber}
                        htmlText={
                          `<span className="cursor-pointer " data-toggle="tooltip" data-placement="top" title="برای کپی کلیک کنید"> <span className="text-hover-primary">  ` +
                          liveData.destinationAccountShebaNumber +
                          ` </span>    </span>`
                        }
                      ></CopyToClipboard>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Tippy>

          {liveData.status == 3 ? (
            <>
              <div className="rounded-2 mb-8  px-3 py-1 pb-5" style={{ border: "2px solid #585858" }}>
                <div
                  className="bg-white px-3 position-absolute d-inline-block "
                  style={{ marginTop: "-14px", width: "auto" }}
                >
                  اطلاعات پرداخت
                </div>
                <Row className="mt-4">
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="4"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90"> تاریخ پرداخت</div>
                    <div className="fw-500">
                      {loadingData ? <Skeleton width={50} height={25} /> : liveData.paymentDate}
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="4"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90"> زمان پرداخت</div>
                    <div className="fw-500">
                      {loadingData ? <Skeleton width={50} height={25} /> : liveData.paymentTime}
                    </div>
                  </Col>
                  <Col
                    xs="12"
                    sm="6"
                    md="4"
                    lg="6"
                    xl="4"
                    className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                  >
                    <div className="mb-sm-1  text-secondary text-small opacity-90"> توضیحات</div>
                    <div className="fw-500">
                      {loadingData ? (
                        <Skeleton width={50} height={25} />
                      ) : liveData.statusDesc ? (
                        liveData.statusDesc
                      ) : (
                        "--"
                      )}
                    </div>
                  </Col>
                  {liveData?.transations?.map((item, index) => (
                    <Fragment key={index}>
                      <Col
                        xs="12"
                        sm="6"
                        md="4"
                        lg="6"
                        xl="4"
                        className="mb-4 d-flex justify-content-between align-items-center d-sm-block"
                      >
                        <div className="mb-sm-1  text-secondary text-small opacity-90"> تراکنش پرداخت به شماره</div>
                        <div className="fw-500">{loadingData ? <Skeleton width={50} height={25} /> : item.id}</div>
                      </Col>

                      {liveData.status == 3 && (
                        <Col xs="12" sm="6" md="4" lg="6" xl="4" className="mb-4">
                          {" "}
                          <button className="btn btn-light-danger mr-2" type="button" onClick={deleteWithdrawal}>
                            <i className="far fa-trash-alt text-small"></i>
                            حذف فرایند انجام شده
                          </button>
                        </Col>
                      )}
                      <Col xs="12" sm="6" lg="6" md="4" xl="4" className="mb-4">
                        <UploadFiles
                          showText={"آپلود رسید"}
                          transationsId={item.id}
                        ></UploadFiles>
                      </Col>
                    </Fragment>
                  ))}
                </Row>
              </div>
            </>
          ) : (
            <div className="rounded-2 mb-8  px-3 py-1 pb-5" style={{ border: "2px solid #585858" }}>
              <div
                className="bg-white px-3 position-absolute d-inline-block "
                style={{ marginTop: "-14px", width: "auto" }}
              >
                تغییر وضعیت
              </div>
              <form id="form" onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col xs="12" sm="6" xl="3">
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-5 w-20"
                          variant="outlined"
                          size="small"
                          margin="normal"
                          placeholder="انتخاب وضعیت"
                          options={enumData?.map((item) => ({
                            value: item.title,
                            label: item.title,
                          }))}
                          field={field}
                          noClear
                        />
                      )}
                    />
                    {errors.status && <span>لطفا یکی از وضعیت ها را انتخاب نمایید</span>}
                  </Col>

                  {watchstatus?.value == "انجام_شد" ? (
                    <>
                      <Col xs="12" sm="6" xl="3">
                        <Controller
                          name="sourceAccountId"
                          control={control}
                          render={({ field }) => (
                            <SelectComponent
                              className="mt-5 w-20"
                              variant="outlined"
                              size="small"
                              margin="normal"
                              placeholder="انتخاب حساب داخلی"
                              options={accountSaamaneh?.map((item) => ({
                                value: item.id,
                                label: item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber,
                              }))}
                              field={field}
                              noClear
                            />
                          )}
                        />
                        {errors.sourceAccountId && <span> لطفا یکی از حساب های داخلی را انتخاب نمایید </span>}
                      </Col>
                      <Col xs="12" sm="6" xl className="mt-5">
                        <Controller
                          name="paymentDateOB"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <ShamsiDatePicker value={value} onChange={onChange} label="" placeholder="تاریخ پرداخت" />
                          )}
                        />
                      </Col>
                      <Col xs="12" sm="6" xl>
                        <Controller
                          name="paymentTime"
                          control={control}
                          rules={{ required: requiredField() }}
                          render={({ field: { onChange, value } }) => (
                            <PatternFormat
                              format="##:##"
                              mask=""
                              customInput={TextField}
                              label="زمان پرداخت"
                              type="search"
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              variant="outlined"
                              margin="normal"
                              className=""
                              size="small"
                              value={value || ""}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.paymentTime && <span>زمان پرداخت نمیتواند خالی باشد</span>}
                      </Col>
                      <Col xs="12" sm="6" xl>
                        <Controller
                          name="trackingCode"
                          control={control}
                          render={({ field: { onChange, value } }) => (
                            <TextField
                              label="کد پیگیری"
                              type="text"
                              className=""
                              variant="outlined"
                              size="small"
                              margin="normal"
                              value={value || ""}
                              onInput={onChange}
                            />
                          )}
                        />
                        {errors.trackingCode && <span>کد پیگیری درست وارد نشده است</span>}
                      </Col>
                    </>
                  ) : (
                    clearedata()
                  )}
                </Row>
                <Row>
                  <Col xs="12" sm="6" xl="3">
                    <Controller
                      name="statusDesc"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="توضیحات"
                          type="text"
                          rows={3}
                          multiline
                          variant="outlined"
                          margin="normal"
                          className=""
                          // placeholder="توضیحات"
                          value={value || ""}
                          onInput={onChange}
                          sx={{
                            ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                              padding: "8.5px 14px 8.5px 0px !important",
                            }
                          }}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <div className="mt-3">
                  <Button variant="success" type="submit" disabled={isSubmitting} className="btn btn-success">
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SaveIcon className="mr-1" />
                    تغییر وضعیت
                  </Button>
                  <Link className="btn btn-danger ml-3" to="/userWithdrawals">
                    <CloseIcon /> بازگشت
                  </Link>
                </div>
              </form>
            </div>
          )}
        </div>
        {/* 3 == انجام شد */}
      </div>
    </div >
  );
};
